export default "__VITE_PUBLIC_ASSET__b155616c__"